import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PermissionListHooks } from "../../Helper/PermissionHelper";
import { hasCreatePermission, hasdeletePermission, hasEditPermission } from "../../Utils/PermissionUtils";
import { toast } from 'react-toastify';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';

function PermissionListComponent() {
    const [permissions, setPermission] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState("Name");
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [SelectedScreenName, setSelectedScreenName] = useState("");

    const canEditPermission = hasEditPermission('Permission');
    const canDeletePermission = hasdeletePermission('Permission');

    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);

    async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
        setLoading(true);
        const data = await PermissionListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
        if (data) {
            setPermission(data.items);
            setTotalPages(data.totalPages);
            setTotalItems(data.totalItems);
        }
        setLoading(false);
    }

    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split("_");
        setSortBy(field);
        setSortDescending(order === "desc");
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id, name) => {
        setSelectedScreenName(name)
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await service.getdata("Permission/DeleteById?id=" + deleteId);
            if (response !== undefined) {
                toast.success('User Permission Deleted successfully!');
                // Replace below with your actual refresh logic
                getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
            }
        } catch (error) {
            toast.error('Error deleting User Permission. Please try again.');
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div>
            <div class="container-fluid content-top-gap">
                <nav aria-label="breadcrumb" class="mb-4">
                    <ol class="breadcrumb my-breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Permission List
                        </li>
                    </ol>
                </nav>
                <div class="accordions">
                    <div class="row">
                        <div class="col-lg-12 mb-4">
                            <div class="card card_border mb-4">
                                <div className="card-header chart-grid__header d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Permission List</h5>
                                    {hasCreatePermission('Permission') && (
                                        <Link to="/CreatePermission" className="btn btn-outline-primary btn-sm">
                                            Add Permission
                                        </Link>
                                    )}
                                </div>
                                <div class="card-body">

                                    <div className="row mb-3">
                                        <div className="col-md-4 ">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by name..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />{" "}
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                onChange={handleSortChange}
                                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                                            >
                                                <option value="Name_asc">Name (A-Z)</option>
                                                <option value="Name_desc">Name (Z-A)</option>
                                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(Number(e.target.value));
                                                    setPageNumber(1); // reset to page 1
                                                }}
                                            >
                                                <option value={10}>Show 10</option>
                                                <option value={20}>Show 20</option>
                                                <option value={50}>Show 50</option>
                                                <option value={100}>Show 100</option>
                                            </select>
                                        </div>
                                    </div>
                                    {loading ? (
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th>S No.</th>
                                                    <th>UserName</th>
                                                    <th>Module</th>
                                                    <th>View</th>
                                                    <th>Create</th>
                                                    <th>Edit</th>
                                                    <th>Delete</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {permissions.map((item, index) => (
                                                    <React.Fragment key={item.permissionId}>
                                                        {/* First row: empty module cells but includes Actions */}
                                                        <tr>
                                                            <td rowSpan={item.lstmodule.length + 1} style={{ border: '1px solid #ccc' }}>{index + 1}</td>
                                                            <td rowSpan={item.lstmodule.length + 1} style={{ border: '1px solid #ccc' }}>{item.userName}</td>
                                                            <td colSpan={5} style={{ border: '1px solid #ccc', fontWeight: 'bold' }}><b>List of Modules</b></td>

                                                            <td rowSpan={item.lstmodule.length + 1} style={{ border: '1px solid #ccc', verticalAlign: 'top' }}>
                                                                <div className="btn-group" role="group">
                                                                    {canEditPermission && (
                                                                        <>
                                                                            <Link to={`/EditPermission/${item.userId}`} className="btn btn-outline-info btn-sm" title="Edit Layout">
                                                                                Edit
                                                                            </Link>
                                                                        </>
                                                                    )}
                                                                    {canDeletePermission && (
                                                                        <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete Permission" onClick={() => handleDeleteClick(item.permissionId,item.userName)}>
                                                                            Delete
                                                                        </Link>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {/* Module rows */}
                                                        {item.lstmodule.map((mod, modIndex) => (
                                                            <tr key={modIndex}>
                                                                <td style={{ border: '1px solid #ccc' }}>{mod.module}</td>
                                                                <td style={{ border: '1px solid #ccc' }}>
                                                                    <input type="checkbox" checked={mod.viewModule} readOnly />
                                                                </td>
                                                                <td style={{ border: '1px solid #ccc' }}>
                                                                    <input type="checkbox" checked={mod.createModule} readOnly />
                                                                </td>
                                                                <td style={{ border: '1px solid #ccc' }}>
                                                                    <input type="checkbox" checked={mod.editModule} readOnly />
                                                                </td>
                                                                <td style={{ border: '1px solid #ccc' }}>
                                                                    <input type="checkbox" checked={mod.deleteModule} readOnly />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </React.Fragment>
                                                ))}

                                            </tbody>
                                        </table>
                                    )}
                                    <div className="text-center">
                                        <button
                                            className="btn btn-outline-primary btn-sm mx-2"
                                            onClick={() => handlePageChange(pageNumber - 1)}
                                            disabled={pageNumber === 1}
                                        >
                                            Previous
                                        </button>{" "}
                                        <span>
                                            Page {pageNumber} of {totalPages}{" "}
                                        </span>
                                        <button
                                            className="btn btn-outline-primary btn-sm mx-2"
                                            onClick={() => handlePageChange(pageNumber + 1)}
                                            disabled={pageNumber === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this User Permission?"
                itemName={SelectedScreenName}
            />
        </div>
    );
}

export default PermissionListComponent;